import { QueryType } from '../../../utils/apollo/graphqlSchema';
import * as ChartControlBarUI from './ChartControlBarUI';
import FunnelControlBar from './FunnelControlBar';
import ExpressionControlBar from './ExpressionControlBar';
import PredictionControlBar from './PredictionControlBar';
import PathControlBar from './PathControlBar';
import RetentionControlBar from './RetentionControlBar';
import { isNil } from 'lodash';
import UnSampleButton from '../UnSampleButton';
import { UnreachableCaseError } from 'ts-essentials';
import { useChartContext } from '../ChartContext';
import { ChartMode } from '../types';

export default () => {
  const {
    metadata: { analysisId, mode, queryType, query },
  } = useChartContext();

  if (
    queryType === QueryType.CohortSample ||
    queryType === QueryType.Significance ||
    queryType === QueryType.DataTable
  ) {
    return null;
  }

  const showUnSample =
    mode === ChartMode.Build &&
    !isNil(query.samplePercentage) &&
    query.samplePercentage !== 100;

  const getControlBar = () => {
    switch (queryType) {
      case QueryType.Expression:
        return <ExpressionControlBar analysisId={analysisId} />;
      case QueryType.Funnel:
        return <FunnelControlBar analysisId={analysisId} />;
      case QueryType.Path:
        return <PathControlBar />;
      case QueryType.Retention:
        return <RetentionControlBar analysisId={analysisId} />;
      case QueryType.Prediction:
        return <PredictionControlBar />;
      default:
        throw new UnreachableCaseError(queryType);
    }
  };

  return (
    <ChartControlBarUI.ControlBarContainer>
      {getControlBar()}
      {showUnSample && (
        <ChartControlBarUI.ControlBarUnSampleContainer>
          <UnSampleButton
            analysisId={analysisId}
            label={`Report is sampled at a rate of ${query.samplePercentage}%`}
            disabled={query.schema.disabled}
          />
        </ChartControlBarUI.ControlBarUnSampleContainer>
      )}
    </ChartControlBarUI.ControlBarContainer>
  );
};
